import CstVerifySuccess from 'features/auth/components/screens/CstVerifySuccess/CstVerifySuccess';
import React from 'react';

export default function CstLinkVerifySuccess() {
  return <CstVerifySuccess />;
}
